import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

export interface LogoSize {
  width: string;
  height: string;
  widthMob: string;
  heightMob: string;
}

export interface ScLogoProps {
  logoSize?: LogoSize;
}

export const ScLogo = styled.a<ScLogoProps>`
  display: block;
  width: fit-content;

  & img {
    width: 100%;
    ${({ logoSize }) =>
      logoSize &&
      css`
        width: ${logoSize.width};
        height: ${logoSize.height};
      `}

    @media (${device.mobile}) {
      height: 32px;

      ${({ logoSize }) =>
        logoSize &&
        css`
          width: ${logoSize.widthMob};
          height: ${logoSize.heightMob};
        `}
    }
  }
`;
